export function getThumbUrl(url: string | undefined | null): string {
    if (!url) return '';
    let thumbUrl = url;

    // 만약 -thumb가 이미 있으면 그대로 리턴
    if (!thumbUrl.match(/-thumb\.[a-z0-9]+$/i)) {
        // 지원하는 포맷에 대해서만 -thumb를 붙여 리턴
        if (thumbUrl.match(/\.(jpg|jpeg|png|webp)$/i)) {
            thumbUrl = thumbUrl.replace(/\.([a-z0-9]+)$/i, '-thumb.$1');
        }
    }

    const targetBase = process.env.VUE_APP_BACKEND || 'https://sun-mooninterior.com';

    // 구버전 및 임시 도메인을 새 도메인(또는 로컬 개발용 백엔드)으로 리라이트
    thumbUrl = thumbUrl.replace(/https?:\/\/old\.sun-mooninterior\.com/gi, targetBase);
    thumbUrl = thumbUrl.replace(/https?:\/\/sunmooninterior1\.cafe24\.com/gi, targetBase);
    thumbUrl = thumbUrl.replace(/https?:\/\/168\.107\.49\.195\.sslip\.io/gi, targetBase);
    thumbUrl = thumbUrl.replace(/https?:\/\/sun-mooninterior\.com/gi, targetBase);

    return thumbUrl;
}

export const getThumbnailUrl = (originalUrl: string): string => {
    if (!originalUrl) return '';
    
    // 환경 변수 기반으로 targetBase 결정
    const targetBase = process.env.VUE_APP_BACKEND || 'https://sun-mooninterior.com';
    
    // 절대 경로(http/https)로 시작하지 않는 경우 targetBase를 붙임
    const fullUrl = originalUrl.startsWith('http') ? originalUrl : `${targetBase}${originalUrl}`;
    
    // Thumbnail generator 파라미터로 변환
    return fullUrl;
}

export function getOriginalUrl(url: string | undefined | null): string {
    if (!url) return '';
    let origUrl = url;

    // Remove -thumb suffix if it exists to ensure we get the original
    origUrl = origUrl.replace(/-thumb\.([a-z0-9]+)$/i, '.$1');

    const targetBase = process.env.VUE_APP_BACKEND || 'https://sun-mooninterior.com';

    // 구버전 및 임시 도메인을 새 도메인(또는 로컬 개발용 백엔드)으로 리라이트
    origUrl = origUrl.replace(/https?:\/\/old\.sun-mooninterior\.com/gi, targetBase);
    origUrl = origUrl.replace(/https?:\/\/sunmooninterior1\.cafe24\.com/gi, targetBase);
    origUrl = origUrl.replace(/https?:\/\/168\.107\.49\.195\.sslip\.io/gi, targetBase);
    origUrl = origUrl.replace(/https?:\/\/sun-mooninterior\.com/gi, targetBase);

    return origUrl;
}
